export default "__VITE_ASSET__0ccfe3d3__"